<template>
  <div id="rules" class="invite avenir">
    <Modal
      v-if="components.rules"
      title="邀请细则"
      :tapToDismiss="true"
      btnPrimary="好"
      :showComplete="false"
      v-on:dismiss="components.rules = false"
      v-on:complete="components.rules = false"
    >
      <div v-if="terms" class="html" v-html="terms" />
    </Modal>
    <p class="small">
      <span class="text">用链接或海报邀请好友代表您已阅读并同意</span>
      <span class="red" @click="components.rules = true">
        <u>邀请细则</u>
      </span>
    </p>
  </div>
</template>

<script>
import Modal from "@/components/popup/Modal"
export default {
  name: "rules",
  components: {
    Modal,
  },
  data() {
    return {
      terms: undefined,
      components: {
        rules: false,
      },
    }
  },
  methods: {
    async getData() {
      const { value_1 } = await this.$api.api.CUSTOM("invite_terms")
      this.terms = value_1
      if (this.$route.query.terms) {
        this.components.rules = true
      }
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style lang="scss">
.html {
  max-height: 60vh;
  overflow: scroll;
  ol {
    padding-inline-start: 5%;
    li {
      list-style-type: decimal;
      font-size: 0.9rem;
      margin: 0 0 10px 0;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "./style.scss";

#rules {
  margin-top: -15px;
  .small {
    font-size: 0.8rem;
    .text {
      opacity: 0.7;
    }
  }
}
</style>
